import * as Yup from 'yup'

const phoneNumberFormat = (value: string) =>
  /\([0-9]{3}\) [0-9]{3}-[0-9]{4}/.test(value) || /[0-9]{10}/.test(value)

export const updatePhoneSchema = () =>
  Yup.object().shape({
    phoneNumbers: Yup.array().of(
      Yup.object().shape({
        extension: Yup.string().nullable(),
        phoneNumber: Yup.string()
          .required('Required')
          // .matches(phoneNumberFormat, 'Must be a valid phone number'),
          .test(
            'Phone Number Format',
            'Must be a valid phone number',
            // @ts-ignore
            phoneNumberFormat
          ),
        phoneNumberType: Yup.string().required('Required'),
        rowId: Yup.string(),
      })
    ),
  })
